import React, { useContext } from "react";
import { GlobalData } from "../Contexts";

export default function useLanguage() {
  const { language } = useContext(GlobalData);
  return language;
}
